import { EditedCollection } from './../models/edited-collection';
import { ErrorHandler, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TrueUpHttpService } from './../../../true-up-http.service';
import { map, catchError} from 'rxjs/operators';

@Injectable()
export class EditedCollectionsService {
  constructor(
    private trueUpDataHttpService: TrueUpHttpService,
    protected errorHandler: ErrorHandler
  ) {}

  public getAllEditedCollections(): Observable<any[]> {
    return this.trueUpDataHttpService
      .get('/editedCollections', null)
      .pipe(
        map(response => response),
        catchError(error => this.handleError(error))
      );
  }

  public postEditedCollections(postBody: EditedCollection): Observable<any> {
    return this.trueUpDataHttpService
      .post('/editedCollections', postBody)
      .pipe(
        map(response => response),
        catchError(error => this.handleError(error))
      );
  }

  public saveEditedCollectionsDistributions(collection: EditedCollection): Observable<any> {
    return this.trueUpDataHttpService
      .post('/editedCollections', collection)
      .pipe(
        map(response => response),
        catchError(error => this.handleError(error))
      );
  }

  private handleError(error: any): Promise<any> {
    this.errorHandler.handleError(error);
    return Promise.reject(error.message || error);
  }
}
